export const sedesData = {
  "Bogotá D.C.": {
    celular: "310 561 0135",
    whatsApp: "https://api.whatsapp.com/send?phone=573105610135",
    direccion: "CL 75A #24 75 Barrios Unidos",
  },
  "Cucuta": {
    celular: "310 561 0135",
    whatsApp: "https://api.whatsapp.com/send?phone=573105610135",
    direccion: "CL 4A #0 65E BARRIO LA CEIBA",
  },
  "Villavicencio": {
    celular: "310 346 6926",
    whatsApp: "https://api.whatsapp.com/send?phone=573103466926",
    direccion: "KRA 19A 19B 38 BARRIO CANTARRANA 1",
  },
  "Bucaramanga": {
    celular: "320 461 0067",
    whatsApp: "https://api.whatsapp.com/send?phone=573204610067",
    direccion: "CL 37 #17 39 CC ONMICENTRO LOCAL 2-1",
  },
  "Santa Rosa de Cabal": {
    celular: "311 262 3681",
    whatsApp: "https://api.whatsapp.com/send/?phone=573112623681&tex&type=phone_number&app_absent=0",
    direccion: "carrera 13 no 12- 59 centro",
  },
  "Tocancipa": {
    celular: "310 337 1677",
    whatsApp: "https://api.whatsapp.com/send/?phone=573103371677&text&type=phone_number&app_absent=0",
    direccion: "Carrea 7 No. 8-02",
  }
};